import { SelectableRosterOrgLogo } from "components/Logo/SelectableRosterOrgLogo";
import { OrgLogoContainer } from "./styles";

interface Props {
  rosterId: string;
  tournamentId: string;
  picked: boolean;
}

export const PickemUserMatchemMatchTeam = ({
  rosterId,
  tournamentId,
  picked,
}: Props) => {
  return (
    <OrgLogoContainer>
      <SelectableRosterOrgLogo
        rosterId={rosterId}
        tournamentId={tournamentId}
        selected={picked}
      />
    </OrgLogoContainer>
  );
};
